interface Props {
	className?: string;
}

export default function RequiredField({ className }: Props) {
	return <span className={`${className} text-red-600 pl-1`}>*</span>;
}
